import React, { useState } from 'react';
import {
  makeStyles, Box, Dialog, DialogContent, useTheme, useMediaQuery,
} from '@material-ui/core';
import AnnouncementBar from 'common/components/AnnouncementBar/AnnouncementBar';
import { withTranslation } from 'config/i18n';
import MainWidgetDialogTitle from 'common/components/MainWidgetDialog/MainWidgetDialogTitle';
import RentalWidgetWrapper from 'common/components/MainWidgetDialog/RentalWidgetWrapper';
import WidgetAlert from 'common/components/MainWidgetDialog/WidgetAlert';
import WidgetWarning from 'common/components/MainWidgetDialog/WidgetWarning';

const useStyles = makeStyles((theme, bikeName) => ({
  widgetContainer: {
    inset: `${theme.spacing(4)} ${theme.spacing(4)} auto auto !important`,
    position: 'fixed',
    transition: 'top, right .3s',
    [theme.breakpoints.down('md')]: {
      position: 'fixed',
      inset: '0 !important',
    },
    '& .MuiBackdrop-root': {
      backgroundColor: 'rgba(255, 255, 255, 0.565)',
    },
    '& .MuiDialog-paper': {
      all: 'initial',
      maxWidth: theme.typography.pxToRem(800),
      width: theme.typography.pxToRem(800),
      margin: 0,
      height: 'auto',
      overflow: 'hidden',
      boxShadow: 'none',
      backgroundColor: 'transparent',
      [theme.breakpoints.down('md')]: {
        maxWidth: '100%',
        width: '100%',
        height: '100%',
      },
    },
  },
  MWDcontainer: {
    overflow: 'hidden',
    border: `2px solid ${theme.palette.grey[300]}`,
    borderRadius: 4,
    height: '100%',
    backgroundColor: 'white',
    transformOrigin: '100% 0%',
    animation: '$floatingWidgetContainer 1.2s cubic-bezier(0.165, 0.840, 0.440, 1.000)',
    [theme.breakpoints.down('sm')]: {
      border: 'none',
      borderRadius: 0,
      transformOrigin: '100% 100%',
      animation: '$floatingWidgetContainerMobile 1.2s cubic-bezier(0.165, 0.840, 0.440, 1.000)',
      overflowY: 'auto',
    },
    '& .MuiDialogContent-root': {
      transformOrigin: '100% 0%',
      animation: '$floatingWidgetContent 1.2s cubic-bezier(0.165, 0.840, 0.440, 1.000)',
      overflow: bikeName && 'hidden',
      paddingTop: bikeName && 0,
    },
  },
  AnnouncementBarWrapper: {
    backgroundColor: theme.palette.grey.A000,
    padding: theme.spacing(1.5, 3),
    margin: theme.spacing(2, -3, -1),
    borderTop: `1px solid ${theme.palette.grey[100]}`,
  },
  '@keyframes floatingWidgetContent': {
    '0%': {
      transform: 'translateY(-100%) scaleX(1)',
      opacity: 0,
    },
    '50%': {
      transform: 'translateY(-100%) scaleX(1)',
      opacity: 0,
    },
    '90%': {
      transform: 'translateY(5%)',
    },
    '100%': {
      transform: 'translateY(0)',
      opacity: 1,
    },
  },
  '@keyframes floatingWidgetContainer': {
    '0%': {
      transform: 'scaleY(0) scaleX(0)',
    },
    '20%': {
      transform: 'scaleY(.2) scaleX(1)',
    },
    '50%': {
      transform: 'scaleY(1)',
    },
  },
  // eslint-disable-next-line mui-unused-classes/unused-classes
  '@keyframes floatingWidgetContainerMobile': {
    '0%': {
      transform: 'scaleY(0) scaleX(0)',
    },
    '50%': {
      transform: 'scaleY(1) scaleX(1)',
    },
  },
}));

const MainWidgetDialog = (props) => {
  const classes = useStyles();
  const {
    t,
    handleClose,
    open,
    image,
    alertMassage,
    bikeName,
    ...restofProps
  } = props;
  const descriptionText = [
    t('fe_es_common_main_widget:future_bookings'),
    t('fe_es_common_main_widget:can_ride_rounded_trip_or_one_way'),
  ];

  const theme = useTheme();
  const fullScreen = useMediaQuery(theme.breakpoints.down('md'));
  const [rentalWidgetWarnings, setRentalWidgetWarnings] = useState([]);
  const updateRentalWidgetWarnings = (warnings) => {
    setRentalWidgetWarnings(warnings);
  };
  return (
    <Dialog
      onClose={handleClose}
      maxWidth="md"
      bikeName={bikeName}
      fullScreen={fullScreen}
      open={open}
      className={classes.widgetContainer}
    >
      <Box className={classes.MWDcontainer}>
        <DialogContent>
          <MainWidgetDialogTitle image={image} bikeName={bikeName} onClose={handleClose} />
          {alertMassage && <WidgetAlert alertMassage={alertMassage} />}
          {rentalWidgetWarnings.length > 0 && <WidgetWarning alertMessage={rentalWidgetWarnings} />}
          <RentalWidgetWrapper
            bordered
            updateRentalWidgetWarnings={updateRentalWidgetWarnings}
            {...restofProps}
          />
          <Box className={classes.AnnouncementBarWrapper}>
            <AnnouncementBar
              title={t('fe_es_common_main_widget:save_even_more')}
              description={descriptionText}
            />
          </Box>
        </DialogContent>
      </Box>
    </Dialog>
  );
};
export default withTranslation(['fe_es_common_main_widget'])(MainWidgetDialog);
